import React, { useRef, useState, useEffect } from "react";
import "./ProductDetails.css";
import ProductEnquiry from "../Enquiry/ProductEnquiry";
import { motion } from "framer-motion";
import categories from "../../assets/Data/categories";
import { useParams, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import ProductCard from "../ProductCard/ProductCard";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import Enquiry from "../Enquiry/Enquiry";
import { AnimatePresence } from 'framer-motion';
function ProductDetails() {
  const handlePopupOpen = () => setShowPopup(true);
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();
  const catName = location.state?.title || "";
  
  const [selectedProductName, setSelectedProductName] = useState("");
  const [zoomPosition, setZoomPosition] = useState({ display: "none" });
  const navigate = useNavigate();
  const swiperRef = useRef(null);
  const { productId } = useParams();
  const { catId } = useParams();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [productId]);

  const handlePopupClose = () => {
    setShowPopup(false);
    setSelectedProductName("");
  };

  const handleEnquiryClick = (productName) => {
    navigate("/ProductEnquiry", { state: { productName: productName } });
  };



  let product = null;
  let relatedProducts = [];
  const relatedProductsNew = categories.flatMap((category) => {
    let response = category.products.filter((product) => product.productId !== productId).map(item => ({ ...item, categories: category }))
    return response;
  }
  );



  for (const category of categories) {
    const foundProduct = category.products.find((p) => p.productId === productId);
    if (foundProduct) {
        product = { ...foundProduct, category }; 
        relatedProducts = category.products
            .filter((p) => p.productId !== productId) 
            .map((p) => ({
                ...p, 
                category, 
                type: p.type 
            }));
        break;
    }
}


  const zoomRef = useRef(null);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;

    setZoomPosition({
      display: "block",
      backgroundImage: `url(${product.img})`,
      backgroundSize: "200%",
      backgroundPosition: `${x}% ${y}%`,
    });
  };

  const handleMouseLeave = () => {
    setZoomPosition({ display: "none" });
  };

  return (

    <div className="proDtls">
      <div className="maxW">
        <div className="bcrumb">
          <div className="breadcrumb">
            <NavLink to="/">Home /</NavLink> <NavLink to={`/Product/${catId}`} >{catName || product.type}</NavLink><span> /  {product.name}</span>
          </div>
        </div>
        <div className="PdtDtlCon">
          <div className="prdDtMn">
            <div className="pdtdMLft">
              <div
                className="pdtWimg"
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
              >
                <img src={product.img} alt={product.name} />
                <div className="zoomLens"></div>
                <div className="zoomedImg" style={zoomPosition}></div>
              </div>
            </div>
            <div className="pdtdMRyt">
              <div className="pdtDinfo">
                <h3>PRODUCT DETAILS</h3>
                <p><strong className="stng">PRODUCT NAME :</strong><span> {product.name}</span></p>
                <p><strong className="stng">PRODUCT TYPE : </strong><span>{product.type}</span></p>

              </div>
              <div className="bdr"></div>
              <div className="pdtEnq">
                <button onClick={() => handleEnquiryClick(product.name)}>
                  PRODUCT ENQUIRY
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="smlrPdt">
          <div>
            {relatedProducts.length > 0 ? (
              <motion.div
                className="hoPrdts prddtss"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: false }}
              >
                <div className="maxW">
                <h4>RELATED PRODUCTS</h4>
                  <div className="smlCol">
                    <Swiper
                      modules={[Autoplay]}
                      ref={swiperRef}
                      loop={true}
                      spaceBetween={20}
                      autoplay={false}
                      // autoplay={{
                      //   delay: 3000,
                      //   disableOnInteraction: false,
                      // }}
                      breakpoints={{
                        2304: { slidesPerView: 7},
                        1800: { slidesPerView:  6 },
                        1600: { slidesPerView: 4.6 },
                        1500: { slidesPerView: 4 },
                        1518: { slidesPerView: 4 },
                        1400: { slidesPerView: 4 },
                        1300: { slidesPerView: 3.5 },
                        1200: { slidesPerView: 3.5 },
                        1100: { slidesPerView: 3.5 },
                        1024: { slidesPerView: 4 },
                        768: { slidesPerView: 3},
                        742: { slidesPerView: 2},
                        540: { slidesPerView: 1.5 },
                        320: { slidesPerView: 1 },
                      }}
                      className="mySwiper"
                    >
                      {relatedProducts.map((product, index) => {

                        return (
                          <SwiperSlide key={product.productId}>
                           <div className="smlpdtss">
                            <div className="smlCards">
                            <ProductCard key={index.toString} {...product} title={product.category.title} catId={product.category.catId} link={product.category.link} />
                            </div>
                           </div>
                          </SwiperSlide>
                        )
                      })}
                    </Swiper>
                  </div>
                </div>
              </motion.div>
            ) : (
              <p >No related products found.</p>
            )}
          </div>
        </div>
    </div>
  );
}

export default ProductDetails;
